import React from 'react';

export const convertNodeToText = (n) => {
  if (n == null || n === false) return '';
  if (typeof n === 'string' || typeof n === 'number') return String(n);
  if (Array.isArray(n)) return n.map(convertNodeToText).join('');
  if (React.isValidElement(n)) {
    const { props = {} } = n;
    const labeled = props['aria-label'] ?? props.title ?? props.label;
    if (labeled != null) return String(labeled);
    return convertNodeToText(props.children);
  }
  return '';
};
